import { BoatType } from "Store/interfaces/products/checkout/riskProducts/BoatProduct";
import { BoatCoverage } from "Store/interfaces/products/coverage";
import { assertExhaustive } from "Utils/functions";
import {
  DEFAULT_DEDUCTIBLE_BOAT,
  DEFAULT_DEDUCTIBLE_SMALL_BOAT,
} from "../boatConstants";
import { BoatInsuranceType } from "../boatTypes";

export const defaultCoverageForBoatType = (
  boatType: BoatType,
): BoatCoverage | undefined => {
  switch (boatType) {
    case BoatType.MOTOR_BOAT_INBOARDS:
      return BoatCoverage.BOAT_MOTOR_FULL_OWN_DAMAGE;
    case BoatType.MOTOR_BOAT_OUTBOARDS:
      return BoatCoverage.BOAT_MOTOR_FULL_OWN_DAMAGE;
    case BoatType.SAILBOAT:
      return BoatCoverage.BOAT_SAILING_BOAT_FULL_OWN_DAMAGE;
    case BoatType.SMALL_BOAT:
      return BoatCoverage.BOAT_ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE;
    default:
      return undefined;
  }
};

export const defaultDeductibleForBoatType = (boatType: BoatType): string => {
  switch (boatType) {
    case BoatType.MOTOR_BOAT_INBOARDS:
    case BoatType.MOTOR_BOAT_OUTBOARDS:
    case BoatType.SAILBOAT:
      return DEFAULT_DEDUCTIBLE_BOAT;
    case BoatType.SMALL_BOAT:
      return DEFAULT_DEDUCTIBLE_SMALL_BOAT;
    default:
      return assertExhaustive(
        boatType,
        new Error(`Unmapped boat type: ${boatType}!`),
      );
  }
};

export const coveragesForBoatType = (boatType?: string): BoatCoverage[] => {
  switch (boatType) {
    case BoatType.MOTOR_BOAT_INBOARDS:
    case BoatType.MOTOR_BOAT_OUTBOARDS:
      return [
        BoatCoverage.BOAT_MOTOR_FULL_OWN_DAMAGE_EXTENDED,
        BoatCoverage.BOAT_MOTOR_FULL_OWN_DAMAGE,
        BoatCoverage.BOAT_MOTOR_REDUCED_OWN_DAMAGE,
      ];
    case BoatType.SAILBOAT:
      return [
        BoatCoverage.BOAT_SAILING_BOAT_FULL_OWN_DAMAGE_EXTENDED,
        BoatCoverage.BOAT_SAILING_BOAT_FULL_OWN_DAMAGE,
        BoatCoverage.BOAT_SAILING_BOAT_REDUCED_OWN_DAMAGE,
      ];
    case BoatType.SMALL_BOAT:
      return [
        BoatCoverage.BOAT_ROWBOAT_CANOE_KAYAK_FULL_OWN_DAMAGE,
        BoatCoverage.BOAT_ROWBOAT_CANOE_KAYAK_REDUCED_OWN_DAMAGE,
      ];
    default:
      return [];
  }
};

export const coverageToDropForBoatType = (
  boatType?: string,
): BoatInsuranceType | undefined =>
  boatType === BoatType.SMALL_BOAT ? BoatInsuranceType.BOAT_SUPER : undefined;
